<div class="container main-font" style="padding-left: 0; padding-right: 7.5px">
  <span class="row g-4 col-12" [ngClass]="{ 'mb-3': data.length > 6 }">
    <div
      *ngFor="let profile of data; let i = index"
      class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
      <mat-card
        class="user-card cursor-pointer"
        (click)="getProfile.emit(profile.user?.id)">
        <label for="imageUpload" class="text-center image-container">
          <img
            [src]="
              utilityService.getSanitizeUrl(
                profile.user?.filestorage?.path ?? ''
              )
            "
            class="avatar image mt-3 rounded-circle"
            type="submit" />
        </label>

        <mat-card-header class="justify-content-center mt-2 small">
          <div
            [matTooltip]="
              (profile.user?.first_name + ' ' + profile.user?.last_name)
                .length > 16
                ? profile.user?.first_name + ' ' + profile.user?.last_name
                : ''
            ">
            {{
              (profile.user?.first_name + ' ' + profile.user?.last_name)
                .length <= 16
                ? profile.user?.first_name + ' ' + profile.user?.last_name
                : (
                    profile.user?.first_name +
                    ' ' +
                    profile.user?.last_name
                  ).slice(0, 16) + '...'
            }}
          </div>
        </mat-card-header>

        <mat-card-content class="align-self-start scroll-role scrollbar pb-0">
          <mat-list>
            <span matListItemLine class="x-small">Ruolo</span>
            <div *ngFor="let role of profile.assignmentroles; let last = last">
              <div>
                <span class="x-small">{{
                  role.alias +
                    ' ( ' +
                    (role.year_total == 0 && role.month_total == 0
                      ? role.day_total +
                        (role.day_total == 1 ? ' giorno' : ' giorni') +
                        ''
                      : (role.year_total != 0
                          ? role.year_total +
                            (role.year_total == 1 ? ' anno' : ' anni')
                          : '') +
                        ' ' +
                        (role.year_total != 0 && role.month_total != 0
                          ? ' e '
                          : '') +
                        (role.month_total != 0
                          ? role.month_total +
                            (role.month_total == 1 ? ' mese' : ' mesi')
                          : '') +
                        (role.month_total == 0 && role.month_total == 0
                          ? ''
                          : '')) +
                    ' )'
                }}</span>
              </div>
              <span class="x-small">{{
                'da ' +
                  (role.startwork_date
                    | date: 'MMM yyyy' : '' : 'it'
                    | titlecase)
              }}</span>
              <span class="x-small">{{
                ' a ' +
                  (role.endwork_date === null
                    ? 'Presente'
                    : (role.endwork_date
                      | date: 'MMM yyyy' : '' : 'it'
                      | titlecase))
              }}</span>
            </div>
          </mat-list>
        </mat-card-content>
      </mat-card>
    </div>
  </span>
</div>
